import OKHeroSection from "./components/HeroSection";
import OKCitiesDirectory from "./components/CitiesDirectory";
import OKStateResources from "./components/StateResources";
import OKFAQSection, { faqs } from "./components/FAQSection";
import OKFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import CitySEOHead from "@/components/feature/CitySEOHead";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens." },
  { name: "New Passport", description: "First-time passport application assistance." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service." },
  { name: "Child Passport", description: "Passport services for minors under 16." },
  { name: "Name Change", description: "Passport correction and name change service." },
  { name: "Second Passport & Damaged", description: "Second passport issuance and damaged passport replacement." },
];

const seoFaqs = faqs.map(f => ({ q: f.question, a: f.answer }));

export default function OklahomaPage() {
  return (
    <>
      <CitySEOHead
        city="Oklahoma"
        state="Oklahoma"
        stateAbbr="OK"
        route="/states/oklahoma"
        title="Oklahoma Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Oklahoma — Oklahoma City, Tulsa, Norman, Edmond, Lawton. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="Oklahoma, United States"
        geoPosition="35.4676;-97.5164"
        faqs={seoFaqs}
        servicesSchema={servicesList}
      />
      <div className="font-sans">
        <OKHeroSection />
        <OKCitiesDirectory />
        <OKStateResources />
        <OKFAQSection />
        <SEOCrossLinks state="OK" />
        <OKFinalCTA />
      </div>
    </>
  );
}